module.exports = __webpack_public_path__ + "static/media/recruitment-banner1.bde06bc1.png";